import { IFastForwardQuestionParams } from 'affiny-core/modules/auth/types';
import { WebRoutes, WebRoutesParams } from 'affiny-web/src/routes';

enum DesktopRoutes {
  Home = '/home',
  Login = '/',
  ProfileDisplay = '/profile-display/:accountId',
  Explore = '/explore',
  Criteria = '/criteria',

  // Interactions
  Favorite = '/favorites-list/:direction?',
  Visits = '/visits',

  // Inbox
  Inbox = '/inbox/:otherAccountId?/:otherAccountIdWithoutThread?',
  PhotoRequests = '/photo-requests',

  // MyProfile
  MyProfile = '/profile-edit',

  // Account
  Settings = `/settings/:category(account|notifications|denylist|community|confidentiality|use|confiance|cookies)?`,
  MySubscription = '/my-subscription',

  // Debug
  LoginDebug = '/loginDebug',
}

export const RoutesNames = {
  ...WebRoutes,
  ...DesktopRoutes,
};

export interface RouteParams extends WebRoutesParams {
  [RoutesNames.ProfileDisplay]: {
    accountId: string;
  };
  [RoutesNames.ProfileCapturePrefix]: IFastForwardQuestionParams & {
    questionIndex?: string;
  };
}
